export const launchRecyclableTab = (
  fullUrl: string,
  onError: (error: Error) => void,
): void => {
  try {
    const parsedUrl = new URL(fullUrl);
    const tabName = parsedUrl.hostname;
    if (window) {
      window.open(parsedUrl.href, tabName);
    } else {
      throw new Error("Not a browser environment");
    }
  } catch (error) {
    onError(error instanceof Error ? error : new Error(String(error)));
  }
};
